import { SlDrawer } from "@shoelace-style/shoelace/shoelace";
import { notNull } from "../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert";
import { ReloadManager } from "../reloadManager";

export class Offerboxer {
    private readonly viewRoot: HTMLElement;

    private readonly reloadManager: ReloadManager;
    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.reloadManager = new ReloadManager();
        this.registerEventListeners();
    }

    private registerEventListeners(): void {
        this.addLayerListener();
        this.addListenerChangeAngebotszeile();
        this.addListenerChangeArtikel();
    }

    private addLayerListener(): void {
        // Layer Zubehoehr aendern
        const layerZubehoerTriggers =
            this.viewRoot.querySelectorAll<HTMLAnchorElement>(
                ".layer-zubehoer-trigger",
            );
        layerZubehoerTriggers.forEach(
            (layerZubehoerTrigger: HTMLAnchorElement) => {
                layerZubehoerTrigger.addEventListener(
                    "click",
                    (event: Event) => {
                        event.preventDefault();

                        const cmsmoduleid = (
                            layerZubehoerTrigger as HTMLElement
                        ).dataset.cmsmoduleid;
                        const drawer = document.querySelector(
                            `#layer_zubehoer_${cmsmoduleid}`,
                        ) as SlDrawer;

                        if (!drawer) {
                            return;
                        }

                        drawer.show();
                        const header = document.querySelector(
                            "#header",
                        ) as HTMLElement;
                        const html = document.querySelector(
                            "html",
                        ) as HTMLElement;

                        header.style.zIndex = "0";
                        html.style.overflow = "hidden";
                        html.style.height = "100%";

                        drawer.addEventListener("sl-after-hide", () => {
                            html.style.removeProperty("overflow");
                            html.style.removeProperty("height");
                            header.style.removeProperty("z-index");
                        });
                    },
                );
            },
        );
    }

    private addListenerChangeAngebotszeile(): void {
        // artikelfarbe oder groesse
        this.viewRoot
            .querySelectorAll<HTMLAnchorElement>(
                ".cms_modul_offerboxer a.trigger_change_angz",
            )
            .forEach((el) => {
                el.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.changeAngebotszeile(el);
                });
            });

        // tarifkennzeichen
        this.viewRoot
            .querySelectorAll<HTMLInputElement>(
                ".cms_modul_offerboxer .trigger_change_angz input",
            )
            .forEach((el) => {
                el.addEventListener("change", (event) => {
                    event.preventDefault();
                    const container = notNull(
                        el.closest(".trigger_change_angz"),
                    ) as HTMLElement;
                    this.changeAngebotszeile(container);
                });
            });
    }

    // klick auf artikelzuordnungsauswahl
    private addListenerChangeArtikel(): void {
        this.viewRoot
            .querySelectorAll<HTMLDivElement>(
                ".cms_modul_offerboxer .handy_name .artzolist",
            )
            .forEach((el) => {
                el.addEventListener("click", (event) => {
                    event.preventDefault();
                    const container = notNull(
                        el.closest(".handy_name"),
                    ) as HTMLElement;
                    container.classList.toggle("open");
                });
            });
    }

    private changeAngebotszeile(container: HTMLElement) {
        const angzid = container.dataset.angzid;
        if (!angzid) {
            return;
        }
        const cmsModuleId = container.dataset.cmsmodulid;
        const cmsModule = document.querySelector(
            `.cms-module-offerboxer[data-module-id="${cmsModuleId}"]`,
        ) as HTMLElement;
        if (!cmsModule) {
            return;
        }
        const form = cmsModule.querySelector(
            "form.select_angz",
        ) as HTMLFormElement;
        if (!form) {
            return;
        }

        (form.querySelector('[name="angzid"]') as HTMLInputElement).value =
            angzid;

        cmsModule
            .querySelectorAll<HTMLInputElement>(".kennzeichen_choose")
            .forEach((checkbox) => {
                const inputName = `kennzeichen[${(checkbox as HTMLInputElement).value}]`;
                const input = form.querySelector(
                    `[name="${inputName}"]`,
                ) as HTMLInputElement;

                if (checkbox.checked) {
                    input.value = (checkbox as HTMLInputElement).value;
                } else {
                    input.value = "";
                }
            });

        this.reloadManager.reloadModule(form);
    }
}
